// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1zgLJ","left":"styles_left__ZI9uj"};